import { Injectable } from '@angular/core';


import { Zona } from '../model/zona';


import { Http, Response, RequestOptions, Headers } from '@angular/http';
import 'rxjs/add/operator/catch';
import { Observable } from 'rxjs/Observable';

import { UtilitiesService } from '../services/utilities.service';

@Injectable()
export class ZonaService {

  constructor(
    private _http: Http,
    private _utilities: UtilitiesService
  ) { }


  getZonas(): Observable<Zona[]> {

    const requestUrl = this._utilities.getURLIIS('zona/GetZonas1');
   
    return this._http.get(requestUrl).map((response: Response) => {
      return <Zona[]>response.json();
    });

  }

}



// WEBPACK FOOTER //
// D:/Proyectos/tpl viejo prueba/eflowTPL/src/app/services/zona.service.ts